<template>
  <div class="nav-box" :style="{paddingTop:statusHei+'px'}">
    <div class="nav" :style="{paddingTop:statusHei+'px',background:scrollColor||bgcolor}">
      <img v-show="!showTit" class="navback" :src="backarrow" @click="back">
      <img v-show="showTit" class="navback" src="//file.40017.cn/appresource/image/ec/icon_navi_back.png" @click="back">
      <p class="title" v-show="alwaysshow||showTit">{{title}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      default: "",
    },
    bgcolor: {
      default: "#f1f2f3",
    },
    rollcolor: {
      default: '#fff'
    },
    backarrow: {
      default: '//file.40017.cn/appresource/image/tin1/icon_back_white.png'
    },
    alwaysshow: {
      default: false
    }
  },
  data() {
    return {
      showTit: false,
      statusHei: 0,
      scrollColor: ''
    }
  },
  created() {
    let that = this;
    _multi_bridge_ready(() => {
      window._tc_bridge_util.set_webview_info({
        param: {
          webview: {
            immersionSwitch: "1",
            dragAble: "false",
          },
        },
      });
      const scrollEv = () => {
        if (window.scrollY > +that.statusHei + 20) {
          that.showTit = true;
          that.scrollColor = this.rollcolor
        } else {
          that.showTit = false;
          that.scrollColor = ""
        }
      };
      window._tc_bridge_user.get_device_info({
        param: {},
        callback: function (data) {
          const dbody = JSON.parse(data.CBData);
          const deviceInfo = dbody.deviceInfo;
          if (window._tc_bridge_public.platform == 1) {
            //安卓
            that.statusHei = +deviceInfo.statusBarHeightPx / 3;
          } else {
            that.statusHei = +deviceInfo.statusBarHeightPx;
          }
          window.removeEventListener("scroll", scrollEv);
          window.addEventListener("scroll", scrollEv);
        },
      });
    })
    
    
  },
  methods: {
    back() {
      this.$emit("back");
    }
  }
}
</script>
<style lang="less" scoped>
.nav-box {
  height: 44px;
  .nav {
    height: 44px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    .navback {
      padding: 10px 0 10px 18px;
      width: 24px;
      height: 24px;
    }
    .title {
      position: absolute;
      font-weight: bold;
      font-size: 16px;
      color: #333;
      left: 50%;
      bottom: 0;
      line-height: 44px;
      z-index: 1;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
}
</style>